import { useState } from 'react'
import DayTripCard from '../../components/DayTripCard'
import useSavedPlaces from '../../hooks/useSavedPlaces'

export const allTrips = [
  {
    id: 'hallstatt',
    title: 'Hallstatt',
    subtitle: "Escape to Austria's Most Iconic Alpine Destination",
    description:
      "Explore Austria's most famous lakeside village surrounded by mountains and stunning scenery. Wander through charm More...",
    image: '/assets/images/day-trip-hallstatt.png',
    tags: ['Hallstatt Village', 'Lake Views', 'Skywalk', 'Photo Stops'],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'swarovski',
    title: 'Swarovski Crystal Worlds',
    subtitle: 'Fairytale Crystal Museum',
    description:
      'Explore the world-famous crystal museum and artistic installations. Experience dazzling displays, creative exhibit. More...',
    image: '/assets/images/day-trip-swarovski.png',
    tags: ['Crystal Worlds', 'Art Exhibitions', 'Family Friendly', 'Gardens'],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'munich',
    title: 'Munich',
    subtitle: 'Bavarian City Escape',
    description:
      'Discover historic landmarks, vibrant squares, and authentic Bavarian culture. Enjoy a day exploring world-famous attractions More...',
    image: '/assets/images/day-trip-munich.png',
    tags: ['Marienplatz', 'City Center', 'Local Markets', 'Historic Sites'],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'saltmines',
    title: 'Salt Mines',
    subtitle: 'Underground Adventure',
    description:
      'Explore fascinating salt mines and learn about centuries of mining history. Enjoy an interactive experience deep. More...',
    image: '/assets/images/day-trip-swarovski.png',
    tags: [
      'Salt Mine Tour',
      'Underground Slides',
      'Family Friendly',
      'Guided Experience',
    ],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'innsbruck',
    title: 'Innsbruck',
    subtitle: 'Heart of the Alps',
    description:
      'Visit the charming alpine city known for its colorful old town and mountain views. Discover historic landmarks More...',
    image: '/assets/images/day-trip-hallstatt.png',
    tags: ['Old Town', 'Golden Roof', 'Alpine Scenery', 'Shopping'],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'werfen',
    title: 'Werfen Ice Cave',
    subtitle: 'Natural Ice Wonderland',
    description:
      "Discover one of the world's largest ice cave systems. Marvel at incredible ice formations and enjoy an unforgettable More...",
    image: '/assets/images/day-trip-munich.png',
    tags: [
      'Ice Cave Tour',
      'Mountain Views',
      'Family Friendly',
      'Scenic Route',
    ],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'eaglesnest',
    title: "Eagle's Nest",
    subtitle: 'Historic Mountain Retreat',
    description:
      'Enjoy breathtaking alpine views and a unique historical landmark. Travel through scenic mountain roads and take in More...',
    image: '/assets/images/day-trip-munich.png',
    tags: ["Eagle's Nest", 'Alpine Panorama', 'Historic Site', 'Scenic Drive'],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'neuschwanstein',
    title: 'Neuschwanstein Castle',
    subtitle: 'Fairytale Castle Experience',
    description:
      "Visit Germany's most famous castle nestled in the Bavarian Alps. Admire stunning architecture and spectacular mount More...",
    image: '/assets/images/day-trip-swarovski.png',
    tags: [
      'Castle Visit',
      'Mountain Views',
      'Scenic Drive',
      'Photo Opportunities',
    ],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'zellamsee',
    title: 'Zell am See',
    subtitle: 'Lakes & Mountains',
    description:
      'Relax by crystal-clear lakes surrounded by beautiful alpine scenery. Stroll along the waterfront and enjoy one of More...',
    image: '/assets/images/day-trip-hallstatt.png',
    tags: ['Lake Promenade', 'Mountain Views', 'Town Center', 'Scenic Drive'],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'kaprun',
    title: 'Kaprun Glacier',
    subtitle: 'Year-Round Alpine Adventure',
    description:
      'Experience breathtaking glacier landscapes and high-altitude viewpoints. Enjoy stunning mountain panoramas and More...',
    image: '/assets/images/day-trip-munich.png',
    tags: ['Glacier Experience', 'Alpine Views', 'Cable Cars', 'Snow Activities'],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'kaprun-2',
    title: 'Kaprun Glacier',
    subtitle: 'Year-Round Alpine Adventure',
    description:
      'Experience breathtaking glacier landscapes and high-altitude viewpoints. Enjoy stunning mountain panoramas and More...',
    image: '/assets/images/day-trip-munich.png',
    tags: ['Glacier Experience', 'Alpine Views', 'Cable Cars', 'Snow Activities'],
    price: '480',
    timeBadge: '8–10 Hours',
  },
  {
    id: 'kaprun-3',
    title: 'Kaprun Glacier',
    subtitle: 'Year-Round Alpine Adventure',
    description:
      'Experience breathtaking glacier landscapes and high-altitude viewpoints. Enjoy stunning mountain panoramas and More...',
    image: '/assets/images/day-trip-munich.png',
    tags: ['Glacier Experience', 'Alpine Views', 'Cable Cars', 'Snow Activities'],
    price: '480',
    timeBadge: '8–10 Hours',
  },
]

export default function DayTripGrid({
  trips,
  onSelectTrip,
}: {
  trips?: any[]
  onSelectTrip?: (trip: any) => void
}) {
  const [searchQuery, setSearchQuery] = useState('')
  const { isSaved, toggleSaved } = useSavedPlaces()

  const activeTrips = trips || allTrips

  const filteredTrips = activeTrips.filter((trip) => {
    const query = searchQuery.toLowerCase()
    const desc = trip.shortDescription || trip.description || ''
    const tagsList = trip.highlights || trip.tags || []

    return (
      trip.title.toLowerCase().includes(query) ||
      trip.subtitle.toLowerCase().includes(query) ||
      desc.toLowerCase().includes(query) ||
      tagsList.some((tag: string) => tag.toLowerCase().includes(query))
    )
  })

  return (
    <>
      {/* Search Bar Input */}
      <div className="w-full max-w-[700px] mt-16 px-4">
        <div className="relative flex items-center">
          <svg
            className="absolute left-6 h-5 w-5 text-slate-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>

          <input
            type="text"
            placeholder="Search Destination"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-14 pr-6 py-4 rounded-full border border-slate-200 bg-white shadow-[0_3px_12px_rgba(0,0,0,0.03)] focus:outline-none focus:ring-2 focus:ring-[#365E92] focus:border-transparent transition-all placeholder:text-slate-400 font-host text-base text-slate-800"
          />
        </div>
      </div>

      {/* Cards Grid Listing */}
      <div className="w-full max-w-page mt-12 px-4 lg:px-[76px]">
        {filteredTrips.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6 justify-items-center">
            {filteredTrips.map((trip, idx) => (
              <div
                key={trip.id + '-' + idx}
                className="w-full flex justify-center animate-fade-in"
              >
                <DayTripCard
                  id={String(trip.id)}
                  title={trip.title}
                  subtitle={trip.subtitle}
                  description={trip.shortDescription || trip.description}
                  image={
                    trip.images && trip.images.length > 0
                      ? trip.images[0]
                      : trip.image
                  }
                  tags={trip.highlights || trip.tags || []}
                  price={trip.price.toString()}
                  timeBadge={
                    trip.duration || trip.timeBadge || '8–10 Hours'
                  }
                  morePath={`/day-trips?id=${trip.id}`}
                  isSaved={isSaved(trip.id)}
                  onSaveToggle={() =>
                    toggleSaved({
                      id: String(trip.id),
                      source: 'day-trip',
                      title: trip.title,
                      duration:
                        trip.duration ||
                        trip.timeBadge ||
                        '8–10 Hours',
                      price: String(trip.price),
                      image:
                        trip.images && trip.images.length > 0
                          ? trip.images[0]
                          : trip.image,
                      explorePath: `/day-trips?id=${trip.id}`,
                    })
                  }
                  onExplore={() => {
                    if (onSelectTrip) onSelectTrip(trip)
                  }}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 px-4 rounded-2xl bg-white/30 border border-white/20 backdrop-blur-sm shadow-sm max-w-[500px] mx-auto mt-6">
            <svg
              className="mx-auto h-12 w-12 text-slate-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>

            <h3 className="mt-4 font-host text-lg font-semibold text-slate-700">
              No Day Trips Found
            </h3>

            <p className="mt-2 font-poppins text-sm text-[#796C6C]">
              We couldn't find any private trips matching "{searchQuery}". Try
              typing another destination, keyword, or tag!
            </p>
          </div>
        )}
      </div>
    </>
  )
}
